"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FoxInputNumber = _interopRequireDefault(require("../components/FoxInputNumber"));

var _asReduxFormField = _interopRequireDefault(require("./asReduxFormField"));

var _wrapFormField = _interopRequireDefault(require("./wrapFormField"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = (0, _wrapFormField.default)((0, _asReduxFormField.default)(_FoxInputNumber.default));

exports.default = _default;